'use client'

import { useEffect } from 'react'
import { auth, onAuthStateChanged } from '@/app/lib/firebase'

export function AuthStateMonitor() {
  useEffect(() => {
    const isDev = process.env.NODE_ENV === 'development'
    // if (isDev) console.log('[Auth Monitor] Setting up auth state listener...')

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      // if (isDev) console.log('[Auth Monitor] Auth state changed')
      // if (isDev) console.log('[Auth Monitor] User:', user ? {
      //   uid: user.uid,
      //   email: user.email,
      //   phoneNumber: user.phoneNumber,
      //   emailVerified: user.emailVerified,
      //   isAnonymous: user.isAnonymous
      // } : null)

      // Store auth state in window for debugging (dev only)
      if (typeof window !== 'undefined' && isDev) {
        ;(window as any).currentUser = user
      }
    })

    return () => {
      // if (isDev) console.log('[Auth Monitor] Cleaning up auth state listener')
      unsubscribe()
    }
  }, [])

  return null // This component doesn't render anything
}
